const DENTAL_LINE = 'DENTAL';

const isDentalLine = (line) => String(line || 'MEDICAL').toUpperCase() === DENTAL_LINE;
const isDentalRdv = (r) => String(r?.type_rendez_vous || '').toUpperCase() === 'DENTISTE';

function filterNursingForConsultIds(nursing, consultIds) {
  if (!nursing) return nursing;
  const match = (row) => !row.consultation_id || consultIds.has(row.consultation_id);
  return {
    vitals: (nursing.vitals || []).filter(match),
    careActions: (nursing.careActions || []).filter(match),
    transfers: (nursing.transfers || []).filter(match)
  };
}

/**
 * Restreint le dossier consolidé à la filière du portail (médecine vs dentaire).
 * @param {object|null} dossier
 * @param {'physician'|'dentist'} workspace
 */
export function filterDossierForWorkspace(dossier, workspace) {
  if (!dossier) return null;

  const consults = dossier.consultations || [];
  const keepDental = workspace === 'dentist';

  const filteredConsults = consults.filter((c) =>
    keepDental ? isDentalLine(c.service_line) : !isDentalLine(c.service_line)
  );
  const consultIds = new Set(filteredConsults.map((c) => c.id));

  const prescriptions = (dossier.prescriptions || []).filter((p) => {
    if (p.consultation_id) return consultIds.has(p.consultation_id);
    if (p.service_line) return keepDental ? isDentalLine(p.service_line) : !isDentalLine(p.service_line);
    return keepDental ? false : true;
  });

  return {
    ...dossier,
    consultations: filteredConsults,
    visits: (dossier.visits || []).filter((v) =>
      keepDental ? isDentalLine(v.service_line) : !isDentalLine(v.service_line)
    ),
    rendezVous: (dossier.rendezVous || []).filter((r) =>
      keepDental ? isDentalRdv(r) : !isDentalRdv(r)
    ),
    prescriptions,
    nursing: filterNursingForConsultIds(dossier.nursing, consultIds)
  };
}
